import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'

const Names = {
  fr: 'portail',
  en: 'portal'
}

const Config: TrPageConfigInterface = {
  name: Names.en,
  path: '/',
  alias: '/',
  meta: {
    title: {
      fr: 'Accueil',
      en: 'Home'
    }
  },
  component: () => import('@/pages/Portal.vue')
}

export { Config }
